<template>
  <div class="card is-min-width-500">
    <header class="bandeau-modal card-header">
    </header>
    <div class="center">
      <div class="columns is-gapless">
        <div class="column mgt-20px">
          <h1 class="title is-size-3">
            {{ title }}
          </h1>
        </div>
      </div>
    </div>
    <div class="card-content mgb-250px">
      <div class="columns">
        <b-field  :label="$t('ajoutEditContrat.produit.addProduit')"
                  class="column is-12 mgb-0">
          <b-autocomplete
              expanded
              v-model="texte"
              :open-on-focus="false"
              :data="produits"
              field="codeLibelle"
              :loading="isFetching"
              @select="newProduit"
              @input="getAsyncProduitData">
            <template slot="empty">
              <div v-if="!isFetching">
                {{$t('ajoutEditContrat.produit.actions.noResult')}}
              </div>
              <div v-else>
                {{$t('ajoutEditContrat.produit.actions.searchEnCours')}}
              </div>
            </template>
          </b-autocomplete>
        </b-field>
      </div>
      <footer>
        <b-field>
          <div class="is-pulled-left boutonAction">
            <a class="button" @click="$parent.close()">
              {{ $t('general.button.cancel')}}
            </a>
          </div>
          <div class="is-pulled-left boutonAction">
            <a class="button is-addOrEdit" @click="ajouter">
              {{ $t('general.button.add') }}
            </a>
          </div>
        </b-field>
      </footer>
    </div>
  </div>
</template>

<script>
import debounce from 'lodash/debounce';
import messageErreur from '@/services/general/messageErreur';
import { getAll as getAllProduit } from '@/api/produit/index';
import { CATEGORIE_PRODUIT } from '@/configuration/catalogue/produitConf';

export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    contratProduits: {
      type: Array,
      required: true,
    },
    societeId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      texte: null,
      produits: [],
      newItem: null,
      isFetching: false,
    };
  },
  methods: {
    newProduit(item) {
      this.newItem = item;
    },
    ajouter() {
      const addItem = {
        produitId: this.newItem.id,
        produit: this.newItem,
      };
      this.$emit('add', addItem);
      this.$parent.close();
    },
    getType(code) {
      return CATEGORIE_PRODUIT.find(p => p.code === code)?.libelle ?? '';
    },
    getAsyncProduitData: debounce(async function produitData() {
      try {
        this.produits = [];
        if (this.texte.length === 0) return;
        this.isFetching = true;
        const result = {
          query: {
            auto: this.texte,
            actif: true,
            societeId: this.societeId,
          },
        };
        const produitFind = (await getAllProduit(result)).data.result.items;
        produitFind
          .forEach(p => {
            p.codeLibelle = `${this.$t(this.getType(p.supportCommercial.categorieVente))} - ${p.reference} - ${p.libelle}`;
          });
        this.produits = produitFind
          .filter(p => !this.contratProduits.map(p => p.produitId).includes(p.id));
        this.isFetching = false;
      } catch (e) {
        messageErreur(this.$i18n);
        this.isFetching = false;
        throw e;
      }
    }, 500),
  },
};
</script>

<style>

</style>
